<template>
	<div class="c-bulk-edit__container">
		<div :class="['c-bulk-edit', { active: selection.length > 0 }]">
			<svg
				@click="close"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM8.53033 7.46967C8.23744 7.17678 7.76256 7.17678 7.46967 7.46967C7.17678 7.76256 7.17678 8.23744 7.46967 8.53033L10.9393 12L7.46967 15.4697C7.17678 15.7626 7.17678 16.2374 7.46967 16.5303C7.76256 16.8232 8.23744 16.8232 8.53033 16.5303L12 13.0607L15.4697 16.5303C15.7626 16.8232 16.2374 16.8232 16.5303 16.5303C16.8232 16.2374 16.8232 15.7626 16.5303 15.4697L13.0607 12L16.5303 8.53033C16.8232 8.23744 16.8232 7.76256 16.5303 7.46967C16.2374 7.17678 15.7626 7.17678 15.4697 7.46967L12 10.9393L8.53033 7.46967Z"
					fill="currentColor"
				/>
			</svg>
			<p>Bulk editing {{ countString }}</p>
			<div class="c-bulk-edit__grid">
				<a class="btn btn-icon btn-box btn-primary" @click="onEditBoards">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-width="1.5"
						/>
					</svg>
					<span> Edit boards </span>
				</a>
				<a class="btn btn-icon btn-box btn-primary" @click="onEditTags">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7.4 7.5H7.6M3 4V11.5858C3 11.851 3.10536 12.1054 3.29289 12.2929L11.7929 20.7929C12.1834 21.1834 12.8166 21.1834 13.2071 20.7929L20.7929 13.2071C21.1834 12.8166 21.1834 12.1834 20.7929 11.7929L12.2929 3.29289C12.1054 3.10536 11.851 3 11.5858 3H4C3.44772 3 3 3.44772 3 4ZM8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5Z"
							stroke="currentColor"
							stroke-width="1.5"
							stroke-linecap="square"
						/>
					</svg>

					<span>Edit tags</span>
				</a>
				<a
					class="btn btn-icon btn-box btn-primary"
					v-if="board"
					@click="onRemoveAdBoard"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M6 6V20C6 20.5523 6.44772 21 7 21H17C17.5523 21 18 20.5523 18 20V6M6 6H18M6 6H4M18 6H20M9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6M14 11V16M10 11V16"
							stroke="currentColor"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Remove from board </span>
				</a>
				<InputButtonChoice
					buttonClass="btn-danger"
					label="Delete Ads"
					@input="onDeleteAds"
				></InputButtonChoice>
			</div>
		</div>
		<ModalEditBoards
			@onSubmit="closeEditBoardsModal"
			ref="editBoards"
			:selection="selection"
		></ModalEditBoards>
		<ModalEditTags
			@onSubmit="closeEditTagsModal"
			ref="editTags"
			:selection="selection"
		></ModalEditTags>
	</div>
</template>

<script>
import FormBulkEdit from '@swipekit/components/form/form-bulk-edit';
import InputButtonChoice from '@swipekit/components/form/input-button-choice';
import ModalEditBoards from '@swipekit/components/modal/modal-edit-boards';
import ModalEditTags from '@swipekit/components/modal/modal-edit-tags';

import generateCsv from '@swipekit/lib/generate-csv';

export default {
	components: {
		FormBulkEdit,
		InputButtonChoice,
		ModalEditBoards,
		ModalEditTags,
	},

	watch: {
		$route: function () {
			this.close();
		},
	},

	computed: {
		selection: function () {
			return this.$store.getters['ads/selection'];
		},
		countString: function () {
			let selection = this.selection;

			let str = `${selection.length} ads`;

			if (selection.length === 1) {
				str = `${selection.length} ad`;
			}

			return str;
		},
		slug: function () {
			return this.$route.params.slug;
		},
		board: function () {
			if (!this.slug) {
				return;
			}
			return this.$store.getters['boards/boardBySlug'](this.slug);
		},
	},

	methods: {
		onEditBoards: function () {
			let editBoards = this.$refs.editBoards;
			editBoards.$data.options.active = true;
		},
		onEditTags: function () {
			let editTags = this.$refs.editTags;
			editTags.$data.options.active = true;
		},
		onGenerateCsv: function () {
			let ads = [];

			let selection = this.selection;

			for (let i = 0; i < selection.length; i++) {
				let ad = this.$store.getters['ads/one'](selection[i]);
				ads.push(ad);
			}

			let csv = generateCsv(ads);

			var encodedUri = encodeURI(csv);
			var link = document.createElement('a');
			link.setAttribute('href', encodedUri);
			link.setAttribute('download', 'swipekit.csv');
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		async onRemoveAdBoard() {
			let adText = 'Ads';

			if (this.selection.length === 1) {
				adText = 'Ad';
			}

			let message = {
				message: `Removing ${this.selection.length} ${adText} from current board`,
				timer: 1750,
			};
			await this.$store.dispatch('message/sendMessage', message);

			let selection = JSON.parse(JSON.stringify(this.selection));

			this.$store.dispatch('ads/clearSelection');

			let board = this.board;

			let payload = {
				selection: selection,
				boardId: board.id,
			};

			// actually remove ads from board
			await this.$store
				.dispatch('ads/bulkRemoveAdsFromBoard', payload)
				.catch((err) => {
					console.log(err);
				});

			message = {
				message: `${adText} removed from current board`,
				status: 'success',
			};

			this.$store.dispatch('boards/refreshAll');

			await this.$store.dispatch('message/sendMessage', message);
		},
		async onDeleteAds() {
			let adText = 'Ads';

			if (this.selection.length === 1) {
				adText = 'Ad';
			}

			let message = {
				message: `Deleting ${this.selection.length} ${adText}`,
				timer: 1750,
			};
			await this.$store.dispatch('message/sendMessage', message);

			let selection = JSON.parse(JSON.stringify(this.selection));

			// trigger removeSelection, this will remove all selected ads from currently viewed ads
			this.$store.dispatch('ads/removeFromSelection');

			this.$nextTick(async () => {
				this.$store.dispatch('ads/clearSelection');

				// actually delete ads
				await this.$store
					.dispatch('ads/bulkDeleteAds', selection)
					.catch((err) => {
						console.log(err);
					});

				message = {
					message: `${adText} deleted`,
					status: 'success',
				};

				// then refresh boards
				this.$store.dispatch('boards/refreshAll');

				await this.$store.dispatch('message/sendMessage', message);
			});
		},
		closeEditTagsModal: function () {
			editTags.$data.options.active = false;
			this.$store.dispatch('app/refreshFilters');
			this.$store.dispatch('ads/clearSelection');
		},
		closeEditBoardsModal: function () {
			editBoards.$data.options.active = false;
			this.$store.dispatch('app/refreshFilters');
			this.$store.dispatch('ads/clearSelection');
		},
		close: function () {
			this.$store.dispatch('ads/clearSelection');
		},
		onKeydown(event) {
			// Check for Ctrl+A (Windows/Linux) or Cmd+A (Mac)
			const isModifier = event.ctrlKey || event.metaKey;
			const isAKey = (event.key || '').toLowerCase() === 'a';

			if (!isModifier || !isAKey) return;

			// Don't override select-all in editable fields
			const target = event.target;
			const tag = target && target.tagName;
			const isEditable =
				(target && target.isContentEditable) ||
				tag === 'INPUT' ||
				tag === 'TEXTAREA' ||
				tag === 'SELECT';

			if (isEditable) return;

			// Prevent default browser select-all
			event.preventDefault();

			// Select all ads in the view cache
			this.selectAllAds();
		},

		// Select all ads from ads/viewCache into ads/selection
		selectAllAds() {
			const ads = this.$store.getters['ads/viewCache'] || [];
			const ids = ads.map((ad) => ad.id);

			// Clear existing selection
			this.$store.dispatch('ads/clearSelection');

			// Add all ids to selection
			for (let i = 0; i < ids.length; i++) {
				this.$store.dispatch('ads/addSelection', ids[i]);
			}
		},
	},

	mounted() {
		// Listen for Cmd+A / Ctrl+A to select all ads
		window.addEventListener('keydown', this.onKeydown);
	},

	beforeDestroy() {
		window.removeEventListener('keydown', this.onKeydown);
	},
};
</script>

<style lang="scss">
.c-bulk-edit {
	--bulk-edit-gap: 32px;
	position: fixed;
	z-index: 999;
	bottom: var(--bulk-edit-gap);
	left: 50%;
	transform: translateX(-50%);
	width: 100%;
	max-width: 634px;
	height: 102px;

	border-radius: var(--border-radius-lg);
	background-color: var(--color-bg-98);
	backdrop-filter: blur(10px);
	padding: var(--spacer-sm);
	box-shadow: 0px 2.2px 5.3px rgba(0, 0, 0, 0.065),
		0px 7.4px 17.9px rgba(0, 0, 0, 0.095), 0px 33px 80px rgba(0, 0, 0, 0.16);

	transition: opacity var(--transition-time) ease-out;

	opacity: 0;
	pointer-events: none;

	&.active {
		opacity: 1;
		pointer-events: all;
	}

	> p {
		color: var(--color-bg-1);
	}

	> svg {
		position: absolute;
		top: var(--margin-lg);
		right: var(--margin-lg);
		cursor: pointer;
		color: var(--color-bg-1);
	}

	&__grid {
		width: 100%;
		max-width: 732px;
		display: flex;

		.btn {
			font-size: var(--font-size-sm);

			&:not(:last-child) {
				margin-right: var(--spacer-sm);
			}

			&.btn-icon {
				padding-left: 8px;
			}

			svg {
				width: 20px;
				height: 20px;
			}
		}
	}

	@media (max-width: 768px) {
		height: 140px;
		&__grid {
			flex-wrap: wrap;

			.btn {
				margin-bottom: var(--margin);
			}
		}
	}
}
</style>
